import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '../../../base/ui/components/web/Button';
import Spinner from '../../../base/ui/components/web/Spinner';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
const useStyles = makeStyles()(theme => {
    return {
        item: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px 12px',
            backgroundColor: theme.palette.ui03,
            borderRadius: theme.shape.borderRadius,
            marginBottom: '6px',
            '&:last-child': {
                marginBottom: 0
            }
        },
        iconContainer: {
            width: '24px',
            height: '24px',
            marginRight: '12px',
            flexShrink: 0,
            '& svg': {
                width: '24px',
                height: '24px',
                borderRadius: theme.shape.borderRadius
            }
        },
        itemInfo: {
            flex: 1,
            minWidth: 0
        },
        itemName: {
            fontSize: '0.875rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        itemMeta: {
            fontSize: '0.75rem',
            color: theme.palette.text03,
            marginTop: '2px'
        },
        buttonContainer: {
            marginLeft: '12px',
            flexShrink: 0
        },
        spinnerContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '70px'
        }
    };
});
/**
 * Reusable list item component for Salesforce records with an action button.
 *
 * @param {IProps} props - Component props.
 * @returns {React.ReactElement}
 */
export const RecordListItem = ({ actionLabelKey, actionType = BUTTON_TYPES.PRIMARY, disabled = false, icon: Icon, isLoading = false, metadata, name, onAction, record }) => {
    const { classes } = useStyles();
    const handleAction = useCallback(() => {
        onAction(record);
    }, [onAction, record]);
    return (React.createElement("div", { className: classes.item },
        React.createElement("div", { className: classes.iconContainer },
            React.createElement(Icon, null)),
        React.createElement("div", { className: classes.itemInfo },
            React.createElement("div", { className: classes.itemName }, name),
            metadata && React.createElement("div", { className: classes.itemMeta }, metadata)),
        React.createElement("div", { className: classes.buttonContainer }, isLoading ? (React.createElement("div", { className: classes.spinnerContainer },
            React.createElement(Spinner, { size: 'small' }))) : (React.createElement(Button, { disabled: disabled, labelKey: actionLabelKey, onClick: handleAction, size: 'small', type: actionType })))));
};
export default RecordListItem;
